<!-- 对接信息 -->
<template>
  <div class="api-doc-page">
    <!-- 基本信息 -->
    <a-card class="base-info-card">
      <div class="section-title">商户接口信息</div>
      <div class="base-info-row">
        <div class="base-info-left">
          <div>
            <span class="label">商户ID：</span>
            <span>{{ merchantId }}</span>
          </div>
          <!-- 选择应用 -->
          <div style="margin-top: 16px;">
            <span class="label">选择应用：</span>
            <a-select v-model="appId" placeholder="请选择应用" style="width: 360px;">
              <a-select-option v-for="app in apps" :key="app.appId" :value="app.appId">
                {{ app.appName }} [{{ app.appId }}]
              </a-select-option>
            </a-select>
          </div>
          <div style="margin-top: 16px;">
            <span class="label">密钥：</span>
            <a-button type="primary" size="small" @click="getSecret" :loading="secretLoading">
              点击查看密钥
            </a-button>
            <a-modal
              v-model="showSecret"
              title="查看密钥"
              :footer="null"
              @cancel="showSecret = false"
            >
              <!-- 商户ID -->
              <div style="margin-bottom: 16px;">
                <span class="label">商户ID：</span>
                <span>{{ merchantId }}</span>
                <a-button type="primary" size="small" @click="copyText(merchantId)">复制商户ID</a-button>
              </div>
              <!-- 应用ID -->
              <div style="margin-bottom: 16px;">
                <span class="label">应用ID：</span>
                <!-- 价格copy按钮 -->
                <span>{{ appId }} </span>
                <a-button type="primary" size="small" @click="copyText(appId)">复制应用ID</a-button>
              </div>
              <!-- 密钥 -->
              <div style="margin-bottom: 16px;">
                <div v-if="secret !== null">
                  <span class="label">密钥：</span>
                  <a-textarea :rows="3" :value="secret" readonly />
                  <a-button type="primary" size="small" style="margin-top: 8px;" @click="copyText(secret)">复制密钥</a-button>
                </div>
                <div style="margin-top: 16px;" v-if="secret !== null">
                  <!-- 复制全部信息 -->
                  <a-button type="primary" size="small" @click="copyAllInfo">复制全部信息</a-button>
                </div>
                <div v-else>
                  <a-spin /> 正在获取密钥...
                </div>
              </div>

            </a-modal>
          </div>
        </div>
        <div class="base-info-right">
          <div>
            <span class="label">在线文档：</span>
            <a-button type="primary" size="small" style="margin-right:8px;" @click="openDoc('pay')">☑ 对接文档</a-button>
            <!-- <a-button type="primary" size="small" @click="openDoc('payout')">☑ 代付API接口文档</a-button> -->
          </div>
          <div style="margin-top: 16px;">
            <span class="label">demo下载：</span>
            <a-button type="primary" size="small" ghost @click="downloadDemo">☉ java</a-button>
          </div>
          <!-- sdk下载 -->
          <div style="margin-top: 16px;">
            <span class="label">sdk下载：</span>
            <a-button type="primary" size="small" ghost @click="downloadSdk">下载</a-button>
          </div>
        </div>
      </div>

    </a-card>
    <a-card class="base-info-card">
      <!-- 通道列表 -->
      <div class="section-title">通道列表</div>
      <jeepay-table
        ref="channelTable"
        :initData="true"
        :reqTableDataFunc="reqTableDataFunc"
        :tableColumns="tableColumns"
        rowKey="id"
        :tableRowCrossColor="true"
      >
        <template slot="rateSlot" slot-scope="{ record }">
          <a-tag color="blue">{{ record.rate }}%</a-tag>
        </template>

        <!-- 单笔最小 -->
        <template slot="minOrderAmountSlot" slot-scope="{ record }">
          <span class="amount-text">{{ formatAmount(record.minOrderAmount) }}</span>
        </template>

        <!-- 单笔最大 -->
        <template slot="maxOrderAmountSlot" slot-scope="{ record }">
          <span class="amount-text">{{ formatAmount(record.maxOrderAmount) }}</span>
        </template>

        <!-- 手续费 -->
        <template slot="fixedFeeAmountSlot" slot-scope="{ record }">
          <!-- 3% 是 商户费率 6 位手续费 -->
          <span class="fee-text">{{ formatFeeDisplay(record) }}</span>
        <!-- <span class="amount-text">[{{formatAmount(record.maxOrderAmount)+ formatAmount(record.fixedFeeAmount) }}]</span> -->
        </template>

        <!-- 账户24小时最大代付金额累计限制 -->
        <template slot="singleAccountPayLimitSlot" slot-scope="{ record }">
          <span class="amount-text">{{ formatAmount(record.singleAccountPayLimit) }}</span>
        </template>

        <!-- 状态 -->
        <template slot="stateSlot" slot-scope="{ record }">
          <a-badge
            :status="record.state === 1 ? 'processing' : 'error'"
            :text="record.state === 1 ? '启用' : '停用'"
          />
        </template>
        <!-- 类型 -->
        <template slot="payTypeSlot" slot-scope="{ record }">
          <a-tag :color="getPayTypeColor(record.payType)">{{ getPayTypeText(record.payType) }}</a-tag>
          <!-- <a-tag :color="record.payType === 0 ? 'blue' : 'green'">{{ record.payType === 0 ? 'Payout' : 'Payin' }}</a-tag> -->
        </template>

        <!-- 通道名称 -->
        <template slot="channelNameSlot" slot-scope="{ record }">
          <!-- 没有展示'--' -->
          <div class="channel-name-text">{{ record.wayName || '--' }}</div>
        </template>
      </jeepay-table>

    </a-card>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getMchAppList, getAppKey, getIntegrationSdk, getIntegrationDemo } from '@/api/integration'
import JeepayCard from '@/components/JeepayCard/JeepayCard.vue'
import JeepayTable from '@/components/JeepayTable/JeepayTable.vue'
import { req } from '@/api/manage'
import { API_URL_MCH_PAYPASSAGE_LIST } from '@/api/channel'
import { tableColumns } from '@/views/channel/tableColumns'
import { formatAmount } from '@/utils/util'
import { getPayTypeText, getPayTypeColor } from '@/utils/constants'

export default {
  name: 'ApiDocPage',
  components: { JeepayCard, JeepayTable },
  data () {
    return {
      showSecret: false,
      secret: null,
      secretLoading: false,
      tableColumns: tableColumns,
      apps: [],
      appId: '',
      tableData: [],
      tableLoading: false
    }
  },
  computed: {
    ...mapState({
      merchantId: state => state.user.belongInfoId || '--'
    })
  },
  mounted () {
    this.loadAppList()
    this.loadChannelList()
  },
  methods: {
    getPayTypeColor,
    getPayTypeText,
    async loadAppList () {
      try {
        const res = await getMchAppList()
        if (res && res.records) {
          this.apps = res.records
          if (this.apps.length > 0) {
            this.appId = this.apps[0].appId
          }
        }
      } catch (error) {
        console.error('获取应用列表失败', error)
        this.$message.error('获取应用列表失败')
      }
    },
    async getSecret () {
      if (!this.appId) {
        this.$message.error('请先选择应用')
        return
      }

      this.showSecret = true
      this.secret = null
      this.secretLoading = true

      try {
        const res = await getAppKey(this.appId)
        this.secret = res.secret || res
      } catch (error) {
        console.error('获取密钥失败', error)
        this.$message.error('获取密钥失败')
        this.secret = '获取失败'
      } finally {
        this.secretLoading = false
      }
    },
    async loadChannelList () {
      this.tableLoading = true
      try {
        const res = await req.list(API_URL_MCH_PAYPASSAGE_LIST, { pageSize: -1 })
        console.log('res', res)
        this.tableData = res.records || []
      } catch (error) {
        console.error('获取通道列表失败', error)
        this.$message.error('获取通道列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    openDoc (type) {
      // todo,是否需要这个功能
      // 该功能正在开发中
      // this.$message.warning('该功能暂未开通')
      // 外链打开
      // todo 后续需要变更 api对接 sdk对接文档
      // https://irispay.gitbook.io/irispay-docs 配置在环境变量里
      window.open(process.env.VUE_APP_DOC_URL, '_blank')
    },
    downloadDemo () {
      getIntegrationDemo().then(res => {
        window.open(res?.[0].url, '_blank')
      }).catch(err => {
        console.log(err)
      })
    },
    reqTableDataFunc (params) {
      return req.list(API_URL_MCH_PAYPASSAGE_LIST, params)
    },
    copyText (text) {
      if (!text) return

      // 优先使用现代 Clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('复制成功')
        }).catch(err => {
          console.error('复制失败:', err)
          this.fallbackCopyText(text)
        })
      } else {
        this.fallbackCopyText(text)
      }
    },

    // 降级复制方法
    fallbackCopyText (text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        this.$message.success('复制成功')
      } catch (err) {
        console.error('复制失败:', err)
        this.$message.error('复制失败，请手动复制')
      }
      document.body.removeChild(textarea)
    },

    copyAllInfo () {
      const text = `商户ID：${this.merchantId}
应用ID：${this.appId}
密钥：${this.secret}`
      this.copyText(text)
    },
    // 格式化金额
    formatAmount,
    // 格式化手续费显示
    formatFeeDisplay (record) {
      const rate = record.rate || 0
      const fixedFee = record.fixedFeeAmount || 0

      if (rate === 0 && fixedFee === 0) {
        return '[免费]'
      }

      let feeText = ''

      // 如果有费率
      if (rate > 0) {
        feeText += `${rate}%`
      }

      // 如果有固定费用
      if (fixedFee > 0) {
        if (feeText) {
          feeText += '+'
        }
        feeText += `${this.formatAmount(fixedFee)}/笔`
      }

      return `[${feeText}]`
    },
    downloadSdk () {
      getIntegrationSdk().then(res => {
        console.log(res?.[0])
        window.open(res?.[0].sdkUrl, '_blank')
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.base-info-card {
  margin-bottom: 24px;
  padding: 24px;
}
.api-doc-page {
  padding: 24px;
  // background: #fafbfc;
}

.base-info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .base-info-left, .base-info-right {
    flex: 1;
  }
}

.label {
  color: #666;
  font-weight: 500;
  width: 100px;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #faad14;
  margin-bottom: 16px;
}

.section-card {
  margin-top: 24px;
}
</style>
